import React, { useRef } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import SearchableSingleSelectDropdown from "../../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../../common/MultilineTextBox";
import {
  addUploadRecordHeader,
  fetchDocumentTypeListForReviewer,
  getRecordHeaderdetails,
  updateUploadRecordHeader,
} from "../../../../../services/UploadRecordsApi";
import TextInput from "../../../../../common/TextInput";
import Snackbar from "../../../../../common/Snackbar";
import OverlayDrawer from "../../../../../common/OverlayDrawer";
import DataTable from "../../../../../common/DataTable";
import moment from "moment";
import Loader from "../../../../../common/Loader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/Store";
import AccordionComponent from "../../../../../common/Accordion";
import { fetchSenderListForTODO } from "../../../../../services/CaseInformationApi";
import {
  setIsUploadFile,
  setIsCancelFiles,
} from "../../../../../redux/slice/CaseHeaderSlice";
import { TRANSCRIPTION_REPORT_STATUS } from "../../../../../common/Constant";
import { GENERAL_LOG_HEADERS } from "../../../../Case_Management/Case_Information/actions/Constant";
import HistorianRecordEditableTable from "../../../Historian/components/HistorianRecordEditableTable";
import { getEditorStatusLogsList } from "../../../../../services/EditorWorkFlowAPI";
import { getAppointmentListByCase } from "../../../../../services/ScheduleAppointmentApi";
import { TRANSCRIPITON_LOGS_HEADERS } from "../../actions/constant";
import { getTranscriberStatusLogsList, transcriberReportStatusUpdate } from "../../../../../services/TranscriberAPI";

interface SelectedRowData {
  actions: { Edit: string };
  additionalComments: string;
  caseInfoId: number;
  caseRecordHeaderId: number;
  documentCategory: string;
  documentTypeId: number;
  documentTypeName: string;
  fileAction: number;
  headerCreatedBy: string;
  headerCreatedDate: string;
  headerModifiedByName: string;
  headerUpdatedDate: string;
  responseCode: number;
  responseMessage: string;
  totalNoOfFiles: number;
}

interface UploadRecordProps {
  caseInfoId: number;
  userData: any;
  loggedInUserid: number | null;
  onCancel: (action: string) => void;
  selectedRowData: SelectedRowData | null;
  onTabChange: any;
  recordActiveTab: string;
  isRowActionTriggered: boolean;
  activeTab: string;
  isEditorFile?: boolean;
  isCompleted?: boolean;
}

interface PartyOption {
  value: string;
  label: string;
  partyCode: string;
}

const TranscriberUploadRecordFile: React.FC<UploadRecordProps> = ({
  caseInfoId,
  userData,
  loggedInUserid,
  selectedRowData,
  isRowActionTriggered,
  onCancel,
  recordActiveTab,
  activeTab,
  onTabChange,
  isEditorFile = false,
  isCompleted = false,
}) => {
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    {
      value: string;
      label: string;
      documentCategory: string;
      documentTypeDescription: string;
    }[]
  >([]);
  const [documentType, setDocumentType] = useState<string | null | number>(
    null,
  );
  const [documentCategory, setDocumentCategory] = useState<string>("");
  const [documentTypeDescription, setDocumentTypeDescription] =
    useState<string>("");
  const [senderOptions, setSenderOptions] = useState<PartyOption[]>([]);
  const [sender, setSender] = useState<string | null | number>(null);
  const [senderCode, setSenderCode] = useState<string>("");
  const [comments, setComments] = useState<string>("");
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [provisionalIdsNew, setProvisionalIdsNew] = useState<any>([]);
  const [result, setResult] = useState<any>({});
  const [logdata, setLogdata] = useState<any[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [documentName, setDocumentName] = useState("");
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean | undefined>(
    false,
  );
  const [appointmentDateOptions, setAppointmentDateOptions] = useState<any[]>(
    [],
  );
  const [parentCaseRecordDetailsId, setParentCaseRecordDetailsId] = useState<
    null | number
  >(null);
  const [documentTypeName, setDocumentTypeName] = useState<string>("");
  const { isUploadFile } = useSelector((state: RootState) => state.caseHeader);
  const dispatch = useDispatch();
  const [isAllCancel, setIsAllCancel] = useState<boolean>(false);
  const [isOnSaveDisable, setIsOnSaveDisable] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const cancelButtonRef = useRef<HTMLButtonElement>(null);
  const [showUploadWarning, setShowUploadWarning] = useState(false);
  const [recordListLogsKey, setRecordListLogsKey] = useState<string | null>("");
  const [statusLogsList, setStatusLogsList] = useState<any[]>([]);
  const [senderName, setSenderName] = useState<string>("");
  const isCompletedWithStatus =
    !!selectedRowData?.caseRecordHeaderId && isCompleted;
  const DISABLE_UPLOAD_DOCS = [
    TRANSCRIPTION_REPORT_STATUS.TRANSCRIPTION_COMPLETED,
  ];

  const fetchHeaderData = async () => {
    try {
      setIsOnSaveDisable(false);
      if (selectedRowData?.caseRecordHeaderId) {
        setLoading(true);
        const data = await getRecordHeaderdetails(
          selectedRowData?.caseRecordHeaderId,
        );

        const firstRecord = data?.result?.[0];
        if (firstRecord) {
          setDocumentType(firstRecord.documentTypeId || null);
          setDocumentTypeName(firstRecord.documentTypeName || "");
          setDocumentCategory(firstRecord.documentCategory || "");
          setSender(String(firstRecord.senderKeyId) || null);
          setSenderCode(firstRecord.senderKeyCode || "");
          setSenderName(firstRecord.senderKeyName || "");
          setDocumentTypeDescription(firstRecord.documentTypeDescription || "");
          setParentCaseRecordDetailsId(firstRecord.parentCaseRecordDetailsId);
          setComments(firstRecord.additionalComments || "");
          setResult(data?.result || {});
          setLogdata([
            {
              createdDate: moment(firstRecord.headerCreatedDate).format(
                "MM/DD/YYYY | HH:mm",
              ),
              modifiedDate: moment(firstRecord.headerModifiedDate).format(
                "MM/DD/YYYY | HH:mm",
              ),
              createdByName: firstRecord.headerCreatedByName,
              modifiedByName: firstRecord.headerModifiedByName,
            },
          ]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userData?.subjectQmeScheduleID) return;

    const fetchData = async () => {
      try {
        const [
          documentCategories,
          partiesList,
          appointmentList,
          transcriberStatusList,
        ] = await Promise.all([
          fetchDocumentTypeListForReviewer(),
          fetchSenderListForTODO(caseInfoId),
          getAppointmentListByCase(caseInfoId),
          getTranscriberStatusLogsList(Number(userData?.subjectQmeScheduleID)),
        ]);

        setDocumentTypeOptions(documentCategories ?? []);
        setSenderOptions(partiesList ?? []);
        setAppointmentDateOptions(appointmentList ?? []);
        setStatusLogsList(transcriberStatusList?.result ?? []);

        if (isEditorFile && partiesList?.length) {
          const selectedParty = partiesList.find(
            (item: any) => item.value === String(loggedInUserid),
          );

          if (selectedParty) {
            setSender(selectedParty.value);
            setSenderCode(selectedParty.partyCode ?? "");
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (!selectedRowData?.caseRecordHeaderId) {
      fetchHeaderData();
    }
  }, [userData?.subjectQmeScheduleID]);

  useEffect(() => {
    if (!isRowActionTriggered) {
      resetData();
    }
  }, [recordActiveTab, activeTab]);

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      fetchHeaderData();
    }
  }, [selectedRowData]);

  const existsSender =
    !!selectedRowData?.caseRecordHeaderId &&
    !!sender &&
    !senderOptions?.some((opt) => opt.value === sender);

  const resetData = () => {
    setDocumentType(null);
    setDocumentCategory("");
    setSender(null);
    setSenderCode("");
    setDocumentTypeDescription("");
    setComments("");
    setFileIds([]);
    setProvisionalIdsNew([]);
    setParentCaseRecordDetailsId(null);
    setResult({});
  };

  const validateForm = () => {
    const errors = [];

    if (!documentType) {
      errors.push("Document Type is mandatory.");
    }

    if (!sender) {
      errors.push("Sender is mandatory.");
    }

    if (documentType && !fileIds?.length) {
      errors.push("Please add at least one record.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsOnSaveDisable(true);
    setLoading(true);
    const existCaseRecordHeaderId = selectedRowData?.caseRecordHeaderId;
    const payloadAdd = {
      caseInfoId: caseInfoId,
      documentTypeId: documentType || null,
      additionalComments: comments?.trim() || "",
      provisionalIds: fileIds.join(", ") || "",
      senderKeyId: Number(sender) || null,
      subjectQmeScheduleId: Number(userData?.subjectQmeScheduleID) || null,
      senderKeyCode: senderCode || "",
      createdBy: loggedInUserid,
    };
    const payloadUpdate = {
      caseRecordHeaderId: selectedRowData?.caseRecordHeaderId,
      caseInfoId: caseInfoId,
      documentTypeId: documentType || null,
      additionalComments: comments?.trim() || "",
      provisionalIds: provisionalIdsNew || "",
      subjectQmeScheduleId: Number(userData?.subjectQmeScheduleID) || null,
      senderKeyId: Number(sender) || null,
      senderKeyCode: senderCode || "",
      createdBy: loggedInUserid,
      modifiedBy: loggedInUserid,
    };

 const payloadReport = {
  subjectQmeScheduleId: userData?.subjectQmeScheduleID,
  reportStatus:
    documentName?.trim() === "Draft Transcription"
      ? "TranscriptionInProgress"
      : documentName?.trim() === "Transcription"
      ? "TranscriptionCompleted"
      : userData?.transcriptionStatus,
};

    try {
      debugger
      let response;
      if (existCaseRecordHeaderId) {
        // Update existing records
        response = await updateUploadRecordHeader(payloadUpdate);
      } else {
        // Create new records
        response = await addUploadRecordHeader(payloadAdd);
      }
      if (response?.isSuccess) {
        const shouldUploadButtonDisable = documentName?.trim() === "Transcription";
        if (documentName?.trim() === "Transcription") {
          await transcriberReportStatusUpdate(payloadReport);
        }
        else if (documentName?.trim() === "Draft Transcription" && userData?.transcriptionStatus === "Transcription Pending"){
          await transcriberReportStatusUpdate(payloadReport);
        }

        setSnackbarMessage(
          existCaseRecordHeaderId
            ? "Records updated successfully."
            : "Records added successfully.",
        );
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onTabChange(shouldUploadButtonDisable);
        }, 1000);
      } else {
        setSnackbarMessage(response?.message || "Failed to process record.");
        setError("error");
        setSnackbarOpen(true);
        setIsOnSaveDisable(false);
      }
    } catch (error) {
      console.error("Error processing record:", error);
      setSnackbarMessage("An error occurred while processing the record.");
      setSnackbarOpen(true);
      setError("error");
      setIsOnSaveDisable(false);
    } finally {
      setLoading(false);
    }
  };
  const handleFileIdsUpdate = (
    ids: string[],
    isSaveDisabled?: boolean,
    fileActions?: any,
  ) => {
    setProvisionalIdsNew(fileActions);
    setFileIds(ids);
    setIsSaveDisabled(isSaveDisabled);
  };

  const handleBack = () => {
    if (isUploadFile) {
      setShowUploadWarning(true);
    } else {
      setShowUploadWarning(false);
      onCancel("Cancel");
    }
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };
  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = async () => {
    setIsCancel(true);
    if (selectedRowData?.caseRecordHeaderId) {
      await fetchHeaderData();
    } else {
      resetData();
    }
    setShowModalNew(false);
  };

  const handleSaveStateChange = (disabled: boolean) => {
    setIsSaveDisabled(disabled);
  };

  const [recordInfoKey, setrecordInfoKey] = useState<string | null>("0");

  useEffect(() => {
    if (documentType) {
      const found = documentTypeOptions.find(
        (doc) => doc.value === documentType,
      );
      if (found) {
        setDocumentName(found.label);
      }
    }
  }, [documentType]);

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      setrecordInfoKey(null);
    } else {
      setrecordInfoKey("0");
      setDocumentName("");
    }
  }, [selectedRowData?.caseRecordHeaderId, recordActiveTab]);

  const lastOpenedRef = useRef<number | null>(null);

  useEffect(() => {
    if (!documentType && !sender) return;

    const handleScroll = () => {
      if (lastOpenedRef.current && Date.now() - lastOpenedRef.current < 300) {
        return;
      }

      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [recordInfoKey, documentType, sender]);

  const hasDisabledDocType = DISABLE_UPLOAD_DOCS.includes(documentTypeName);

  const hasInvalidDocumentType =
    !!selectedRowData?.caseRecordHeaderId &&
    !!documentType &&
    !documentTypeOptions?.some((opt) => opt.value === documentType);

  const existsDocType =
    isCompletedWithStatus || hasDisabledDocType || hasInvalidDocumentType;

  const recordInfoAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          recordInfoKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}{" "}
              <span className="fw-normal">
                {existsDocType
                  ? documentTypeName && ` - ${documentTypeName} `
                  : documentName && ` - ${documentName} `}
              </span>
            </>
          ),
      }))}
      activeKey={recordInfoKey}
      onSelect={(key) => {
        lastOpenedRef.current = Date.now();
        setrecordInfoKey(key as string);
      }}
    />
  );

  const [attachmentKey, setattachmentKey] = useState<string | null>("0");

  const attachmentAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={attachmentKey}
      onSelect={(key) => setattachmentKey(key as string)}
    />
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isUploadFile) return;
      const target = event.target as HTMLElement;
      // Check if the element or its parent has a "pointer" cursor
      const hasPointerCursor = (element: HTMLElement | null): boolean => {
        while (element) {
          const style = window.getComputedStyle(element);
          if (style.cursor === "pointer") return true;
          element = element.parentElement;
        }
        return false;
      };

      const isButton =
        target.tagName === "BUTTON" ||
        target.closest("button") ||
        target.classList.contains("btn") ||
        target.closest(".btn");

      const isTab =
        target.classList.contains("tab") ||
        target.closest(".tab") ||
        target.classList.contains("nav-link") ||
        target.closest(".nav-link");

      const isInteractiveElement =
        isButton ||
        isTab ||
        target.closest("a.nav-link") ||
        target.closest("[role='tab']") ||
        target.closest("input") ||
        target.closest("label") ||
        target.closest("select") ||
        target.closest("a") ||
        target.closest("[data-ignore-click-outside]") ||
        target.closest('[data-actionable="true"]') ||
        hasPointerCursor(target);

      // NEW: Check if the click is inside a modal or message element
      const isInModalOrMessage =
        target.closest(".modal") ||
        target.closest(".toast") ||
        target.closest(".alert") ||
        target.closest("[role='alert']") ||
        target.closest("[aria-live='polite']");

      const isCancelUploadButton = target.closest("#cancel-upload-button");
      const isInsideDrawer = Boolean(target.closest("#log-overlay-drawer"));
      const isInsideContainer =
        containerRef.current && containerRef.current.contains(target);
      // Check if click is outside the container
      const isOutside = !(
        isInsideContainer ||
        isCancelUploadButton ||
        isInsideDrawer
      );

      if (isOutside && !isInModalOrMessage) {
        if (isInteractiveElement) {
          setShowUploadWarning(true);
        } else {
          setShowUploadWarning(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isUploadFile]);

  const handleUploadInteraction = () => {
    setShowUploadWarning(false);
    dispatch(setIsUploadFile(false));
    dispatch(setIsCancelFiles(true));
    setIsAllCancel(true);
  };

  const handleCloseModalWarning = () => {
    setShowUploadWarning(false);
  };

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      setrecordInfoKey(null);
    } else {
      setrecordInfoKey("0");
    }
    setIsAllCancel(false);
  }, [selectedRowData?.caseRecordHeaderId, recordActiveTab]);

  useEffect(() => {
    const handleScroll = () => {
      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);

      if (documentType && sender) {
        setrecordInfoKey(null);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [recordInfoKey, documentType, sender]);

  return (
    <Container fluid className="pb-5" ref={containerRef}>
      <Loader isLoading={loading} />
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />

      {recordInfoAccordion([
        {
          title: "Record Information",
          content: (
            <>
              <Row>
                {existsDocType ? (
                  <Col sm={3}>
                    <TextInput
                      label="Document Type"
                      name="documentType"
                      value={documentTypeName}
                      disabled
                      isDropdown={true}
                    />
                  </Col>
                ) : (
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Document Type"
                      name="documentType"
                      required={true}
                      options={documentTypeOptions}
                      value={documentType}
                      onChange={(e, name, value) => {
                        setDocumentType(value);
                        setComments("");
                        const selectedType = documentTypeOptions?.find(
                          (item) => item.value === value,
                        );
                        if (selectedType) {
                          setDocumentCategory(
                            selectedType?.documentCategory || "",
                          );
                          setDocumentTypeDescription(
                            selectedType?.documentTypeDescription || "",
                          );
                        }
                      }}
                      disabled={result[0]?.caseRecordHeaderId}
                    />
                  </Col>
                )}

                <Col sm={3}>
                  <TextInput
                    label="Category"
                    name="documentCategory"
                    value={documentCategory}
                    disabled
                  />
                </Col>

                <Col sm={6}>
                  <TextInput
                    label="Document Type Description"
                    name="documentTypeDescription"
                    value={documentTypeDescription}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                {existsSender ? (
                  <Col sm={6}>
                    <TextInput
                      label="Sender"
                      name="sender"
                      value={senderName}
                      disabled
                      isDropdown={true}
                    />
                  </Col>
                ) : (
                  <Col sm={6} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Sender"
                      name="sender"
                      required={true}
                      options={senderOptions}
                      value={sender}
                      onChange={(e, name, value) => {
                        setSender(value);
                        const selectedCode = senderOptions?.find(
                          (item) => item.value === value,
                        );
                        if (selectedCode) {
                          setSenderCode(selectedCode?.partyCode || "");
                        }
                      }}
                      disabled={result[0]?.caseRecordHeaderId}
                    />
                  </Col>
                )}
                <Col sm={6} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Appointment Date & Time"
                    name="ADT"
                    required={true}
                    options={appointmentDateOptions}
                    value={String(userData?.subjectQmeScheduleID)}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12}>
                  <MultilineTextBox
                    label="Additional Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={300}
                    disabled={existsDocType}
                  />
                </Col>
              </Row>
            </>
          ),
        },
      ])}

      {documentType && (
        <>
          {" "}
          {attachmentAccordion([
            {
              title: "Attachments",
              content: (
                <>
                  {documentType ? (
                    <Row className="align-items-center">
                      <HistorianRecordEditableTable
                        caseInfoId={caseInfoId}
                        comments={comments}
                        onFileIdsUpdate={handleFileIdsUpdate}
                        result={result}
                        isCancel={isCancel}
                        documentType={documentType}
                        isRowActionTriggered={isRowActionTriggered}
                        selectedRowData={selectedRowData}
                        recordActiveTab={recordActiveTab}
                        activeTab={activeTab}
                        isAllCancel={isAllCancel}
                        setIsAllCancel={setIsAllCancel}
                        existsDocType={existsDocType}
                        documentTypeName={documentName || documentTypeName}
                      />
                    </Row>
                  ) : (
                    ""
                  )}
                </>
              ),
            },
          ])}
        </>
      )}
      <AccordionComponent
        items={[
          {
            title: "Transcriber Logs",
            content: (
              <Row>
                <DataTable
                  headers={TRANSCRIPITON_LOGS_HEADERS}
                  rows={statusLogsList}
                />
              </Row>
            ),
          },
        ]}
        activeKey={recordListLogsKey}
        onSelect={(key) => setRecordListLogsKey(key as string)}
      />
      <Row className="mb-3 mt-3">
        <Col className="d-flex justify-content-start">
          {isEditorFile && (
            <Button
              variant="outline"
              className="d-flex align-items-center btn-text-border me-1"
              onClick={handleBack}
            >
              <span className="material-icons mr-2 ">arrow_back</span>
              Back
            </Button>
          )}
          {userData?.caseInfoId ? (
            <>
              {!isEditorFile && (
                <Button
                  variant="outline"
                  className="d-flex align-items-center btn-text-border me-1"
                  onClick={handleBack}
                >
                  <span className="material-icons mr-2 ">arrow_back</span>
                  Back
                </Button>
              )}
              {isRowActionTriggered ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={
                    <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                      Logs
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center mx-2 me-0"
                    onClick={handleOpenDrawer}
                  >
                    <span className="material-icons">description</span>
                  </button>
                </OverlayTrigger>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </Col>
        <Col className="d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-center m-0"
            onClick={handleCancelButton}
            disabled={isSaveDisabled || existsDocType || isOnSaveDisable}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="d-flex align-items-center mx-2"
            onClick={handleSubmit}
            disabled={isSaveDisabled || existsDocType || isOnSaveDisable}
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Col>
      </Row>

      <OverlayDrawer
        title={"Logs"}
        open={drawerOpen}
        onClose={handleCloseDrawer}
        placement="bottom"
      >
        <DataTable
          headers={GENERAL_LOG_HEADERS}
          rows={logdata}
          isLogTable={true}
        />
      </OverlayDrawer>

      <Modal show={showModalNew} onHide={handleCloseModalNew}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to cancel?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalNew}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmCancelButton}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        data-ignore-click-outside
        show={showUploadWarning}
        onHide={handleCloseModalWarning}
      >
        <Modal.Body className="fw-bold text-left modelheading">
          <div>
            Your files are currently uploading. Cancelling now will discard any
            in-progress uploads. Are you sure?
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalWarning}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            id="cancel-upload-button"
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleUploadInteraction}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default TranscriberUploadRecordFile;
